"use client";

import { Typography } from "@/components/ui/typography";
import type { IndustryProcessProps } from "./types";
import { industryProcessCards } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { ProcessCards } from "@/components/screen/global-components/process";
import { Button } from "@/components/ui/button";
import Link from "next/link";

const IndustryProcess = ({ className }: IndustryProcessProps) => {
  return (
    <section className={cn("section lg:bg-background-secondary", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4">
          <Typography variant="heading4" className="md:text-center">
            <h2>How our translation services work</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 max-w-[780px] mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>
                Our proprietary process ensures the highest accuracy at the
                quickest pace. Using a multi-human workflow with built-in
                quality assurance validation, we achieve fast and consistent
                precision across even the most complex, high-volume projects.
              </p>
            </Typography>
          </div>
        </div>
        <ProcessCards cards={industryProcessCards} className="mt-6 md:mt-12" />
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href="/quality-guarantee" className="!text-base">
              Explore our quality guarantee
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default memo(IndustryProcess);
